<!-- (c) Santosh Sahoo -->
<template>
  <div class="form-group" :class="{ required, 'has-error': !!error }">
    <label v-if="label" :for="uid" class="form-label">{{ label }}</label>
    <select :id="uid" class="form-control form-select" :multiple="multiple" :value="modelValue" v-bind="$attrs"
      @change="$emit('update:modelValue', $event.currentTarget.value)">
      <option v-if="placeholder" :value="''">{{ placeholder }}</option>
      <template v-if="groupBy">
        <optgroup v-for="(list, key) in groupByFn(options, groupBy)" :key="key" :label="key">
          <option v-for="o in sortBy(list, labelKey)" :key="o[valueKey]" :value="o[valueKey]">
            {{ o[labelKey] ?? ("[Blank]") }}
          </option>
        </optgroup>
      </template>
      <template v-else>
        <option v-for="o in options" :key="o[valueKey]" :value="o[valueKey]">
          {{ o[labelKey] ?? ("[Blank]") }}
        </option>
      </template>
    </select>

    <div v-if="error" class="form-text">
      {{ error }}
    </div>
  </div>
</template>

<script>
  import { groupBy, sortBy } from "lodash";
  import { basicFormProps } from "./props";

  export default {
    inheritAttrs: false,
    props: {
      ...basicFormProps,
      options: Array,
      multiple: Boolean,
      canAdd: Boolean,
      valueKey: { type: String, default: "value" },
      labelKey: { type: String, default: "label" },
      groupBy: String,
    },
    emits: ["update:modelValue"],
    methods: {
      sortBy,
      groupByFn: groupBy,
    },
  };
</script>
